/** Isoliertes Datenmodell: Seminar-Abendessen (Dinner-Dispatch). */

export interface SeminarDinnerDay {
  tagId: string;
  label: string; // z.B. "Samstagabend", "Sonntagabend"
  datum: string;
  restaurantName?: string;
  adresseTreffpunkt?: string;
  uhrzeit?: string;
}

export interface SeminarDinnerConfig {
  seminarId: string;
  titel: string;
  tage: SeminarDinnerDay[];
  /** Phase-1 Einladung: E-Mail (lowercase) → ISO-Zeitpunkt des Versands */
  invitationMailSentAtByEmail?: Record<string, string>;
}

export interface SeminarDinnerRegistration {
  id: string;
  seminarId: string;
  name: string;
  email: string;
  /** Key: tagId, Value: Personenanzahl (0..n) */
  anmeldungen: Record<string, number>;
  bemerkung?: string;
  angemeldetAm: string;
  isManualEntry: boolean;
  /** Phase-2 Location-Dispatch: ISO-Zeitpunkt, sobald Details-Mail in mail_queue lag */
  locationMailSentAt?: string;
}

export const SEMINAR_DINNER_CONFIGS_COLLECTION = 'seminar_dinner_configs';
export const SEMINAR_DINNER_REGISTRATIONS_COLLECTION = 'seminar_dinner_registrations';

/** Soft-Deadline: Hinweis ab diesem Abstand vor Seminarbeginn (kein Hard-Block). */
export const SEMINAR_DINNER_SOFT_DEADLINE_DAYS = 7;
